import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./auth/config";
import { MsalProvider } from "@azure/msal-react";
import { GoogleOAuthProvider } from "@react-oauth/google";
// import "./cstheme.css";
import "./index.css";
import 'cstheme.css' ;
// import "primereact/resources/themes/lara-light-cyan/theme.css";


const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const msalInstance = new PublicClientApplication(msalConfig);
root.render(
  // <React.StrictMode>
  <MsalProvider instance={msalInstance}>
    <Provider store={store}>
      <BrowserRouter>
        <GoogleOAuthProvider clientId={"7807972456-hj26keo1tdhfo77fjgv7s9qv7mterpv7.apps.googleusercontent.com"}>
          <App />
        </GoogleOAuthProvider>
      </BrowserRouter>
    </Provider>
  </MsalProvider>
  // {/* </React.StrictMode> */}
);
